<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button variant="outline-primary" class="mx-2" @click="toCancel">
            <i class="mc-fa icon-fill_close"></i> {{ $t('global.cancel') }}
          </b-button>
          <b-button :disabled="isSubmit" variant="primary" type="button" @click="toSave">
            <i class="mc-fa icon-outline_save"></i> {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
    <b-row>
      <b-col :md="form.report ? 8 : 12">
        <div class="mc-form">
          <div class="clearfix mb-3">
            <h4 class="card-title">
              {{ $t('report.title.reportInformation') }}
            </h4>
          </div>
          <b-card>
            <b-row class="mb-3">
              <b-col cols="4">
                <b-form-group
                  :label="$t('report.title.scheduleName')"
                  label-for="schedule-name"
                  label-class="required"
                >
                  <b-form-input
                    id="schedule-name"
                    v-model="form.scheduleName"
                    :placeholder="$t('report.title.scheduleName')"
                    :class="{ 'is-invalid': $v.form.scheduleName.$error }"
                  />
                  <div v-if="$v.form.scheduleName.$error" class="invalid-feedback">
                    <span v-if="!$v.form.scheduleName.required">
                      {{ $t('report.title.scheduleName') }}
                      {{ $t('global.validation.required') }}
                    </span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  :label="$t('report.title.reportType')"
                  label-for="report-name"
                  label-class="required"
                >
                  <b-input-group :class="{ 'is-invalid': $v.form.reportName.$error }">
                    <b-form-input
                      class="pe-4"
                      id="report-name"
                      v-model="displayValueReportName"
                      readonly
                      :placeholder="`Pilih laporan yang akan dijadwalkan`"
                      @click="openModalReport"
                      :class="{ 'is-invalid': $v.form.reportName.$error }"
                    />
                    <template #append>
                      <i class="mc-icon icon-outline_menu append-icon" />
                    </template>
                  </b-input-group>

                  <div v-if="$v.form.reportName.$error" class="invalid-feedback">
                    <span v-if="!$v.form.reportName.required">
                      {{ $t('report.title.reportType') }}
                      {{ $t('global.validation.required') }}
                    </span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div class="clearfix mb-3">
              <h4 class="card-title">{{ $t('report.title.deliveryPeriod') }}</h4>
            </div>
            <b-form-group>
              <b-row class="align-items-center my-3" v-if="haveDailyOption">
                <b-col md="3">
                  <b-form-radio v-model="form.period" value="d">
                    <label class="radio-label">{{ $t('report.object.everyDay') }}</label>
                  </b-form-radio>
                </b-col>
                <b-col md="3">
                  <date-picker
                    v-model="form.time"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    placeholder="HH:mm"
                    :disabled="form.period != 'd'"
                  />
                  <span
                    v-if="form.period == 'd' && !isValidTime"
                    class="text-danger text-sm-italic"
                    >{{ $t('global.validation.required') }}</span
                  >
                </b-col>
              </b-row>
              <b-row class="align-items-center my-3" v-if="haveWeeklyOption">
                <b-col md="3">
                  <b-form-radio v-model="form.period" value="w">
                    <label class="radio-label">{{ $t('report.object.everyWeek') }}</label>
                  </b-form-radio>
                </b-col>
                <b-col md="3">
                  <b-form-group
                    label-for="period"
                    :invalid-feedback="invalidNoOfDay"
                    :state="stateNoOfDay"
                  >
                    <multiselect
                      id="period"
                      v-model="form.noOfDay"
                      :options="dayOptions"
                      track-by="value"
                      label="text"
                      :placeholder="$t('report.action.selectDate')"
                      openDirection="bottom"
                      :disabled="form.period != 'w'"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <div class="float-end">{{ $t('global.time.hours') }}</div>
                </b-col>
                <b-col md="3">
                  <date-picker
                    v-model="form.timeWeek"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    placeholder="HH:mm"
                    :disabled="form.period != 'w'"
                  />
                  <span
                    v-if="form.period == 'w' && !isValidTime"
                    class="text-danger text-sm-italic"
                    >{{ $t('global.validation.required') }}</span
                  >
                </b-col>
              </b-row>
              <b-row class="align-items-center my-3" v-if="haveMonthlyOption">
                <b-col md="3">
                  <b-form-radio v-model="form.period" value="m">
                    <label class="radio-label">{{ $t('report.object.everyMonth') }}</label>
                  </b-form-radio>
                </b-col>
                <b-col md="3">
                  <b-form-group
                    label-for="period"
                    :invalid-feedback="invalidNoOfDate"
                    :state="stateNoOfDate"
                  >
                    <multiselect
                      id="period"
                      v-model="form.noOfDate"
                      :options="dateOptions"
                      :placeholder="$t('global.action.selectDate')"
                      openDirection="bottom"
                      :disabled="form.period != 'm'"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="1" sm="1">
                  <div class="float-end">{{ $t('global.time.hours') }}</div>
                </b-col>
                <b-col md="3">
                  <date-picker
                    v-model="form.timeMonth"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    placeholder="HH:mm"
                    :disabled="form.period != 'm'"
                  />
                  <span
                    v-if="form.period == 'm' && !isValidTime"
                    class="text-danger text-sm-italic"
                    >{{ $t('global.validation.required') }}</span
                  >
                </b-col>
              </b-row>
              <b-row>
                <div class="my-2">
                  <h5>{{ $t('dashboard.scheduler.form.deliveryPeriod') }}</h5>
                </div>
              </b-row>
              <b-row class="my-2">
                <b-col md="4">
                  <b-form-group>
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label>
                          {{ $t('dashboard.scheduler.form.startDate') }}
                          <i class="text-danger">*</i>
                        </label>
                      </div>
                    </template>
                    <date-picker
                      v-model="form.startDate"
                      format="DD MMM YYYY"
                      value-type="YYYY-MM-DD"
                      :lang="datePickerLang"
                      type="date-picker"
                      :placeholder="$t('global.action.selectDate')"
                      validation="required"
                      :disabled-date="disabledRangeStart"
                      :class="{ 'is-invalid': $v.form.startDate.$error }"
                    />
                    <div v-if="$v.form.startDate.$error" class="invalid-feedback">
                      <span v-if="!$v.form.startDate.required">
                        {{ $t('dashboard.scheduler.form.startDate') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <div class="d-flex justify-content-center align-self-center">-</div>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label>{{ $t('dashboard.scheduler.form.endDate') }}</label>
                      </div>
                    </template>
                    <date-picker
                      v-model="form.endDate"
                      format="DD MMM YYYY"
                      value-type="YYYY-MM-DD"
                      :lang="datePickerLang"
                      type="date-picker"
                      :placeholder="$t('global.action.selectDate')"
                      validation="required"
                      :disabled-date="disabledRangeEnd"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="align-items-center my-3 px-2" ref="descRef">
                <McAlert v-if="alertDesc" variant="info" :text="alertDesc" withIcon />
              </b-row>
            </b-form-group>
          </b-card>

          <b-card style="margin-bottom: 200px">
            <b-row class="mb-3">
              <Contact
                ref="contactRef"
                :title="$t('report.title.determineRecipients')"
                :fields="fields"
                :hasData="true"
                :hasEmptyState="false"
                @customTag="addTag"
                @updateCountryCode="updateCountryCode"
                @updateData="updateData"
              />
            </b-row>
            <b-row class="align-items-center my-3 px-2">
              <McAlert variant="info" :html="$t('report.text.emailWarning')" withIcon />
            </b-row>
          </b-card>
        </div>
      </b-col>
      <b-col :md="4" v-if="form.report && !form.isSavedReport">
        <FilterReport
          ref="filterReportRef"
          :report="form.report"
          :title="form.reportName"
          :period="form.period"
          :defaultColumnOrder="defaultColumn"
          :initialFilter="form.filter"
          @columnUpdated="updateColumn"
          @updateFilter="updateFilter"
        />
      </b-col>
    </b-row>

    <ModalReportScheduler
      ref="modalReportScheduler"
      @onSelect="onSelect"
      :reportOptions="reportOptions"
    />
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import { Helper } from '@/mixin/helper'
import Layout from '@/router/layouts/main'
import {
  CREATE_REPORT_SCHEDULER,
  EXPORT_GET_CONTACTS_REPORT,
  GET_DETAIL_REPORT_SCHEDULER,
  UPDATE_REPORT_SCHEDULER,
} from '@/services/api/report/report'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

import McAlert from '@/components/McAlert'
import { mapCsv, mapPeriode31DaysLeft, scopeReportScheduler } from '../lib/reportKeyLists'
import reportList from '../lib/reportList'
import reportFilterFields from '@/router/views/report/components/ModalFilter/components/InputTableFilter/lib/reportFilterFields'
import ModalReportScheduler from './components/ModalReportScheduler.vue'
import datePickerLang from '@/helpers/date-picker-lang'
import Contact from '../components/Contact'
import FilterReport from './components/FilterReport.vue'
import alertFields from '../list/alert/lib/fields/fields'
import detailSummaryTripFields from '../list/detail-vehicle-trip/lib/fields/fields'
import fuelFields from '../list/fuel/lib/fields/fields'
import geolocationFields from '../list/geolocation/lib/fields/fields'
import managementDriverFields from '../list/management-driver/lib/fields/fields'
import managementVehicleFields from '../list/management-vehicle/lib/fields/fields'
import vehicleOfflineFields from '../list/offline-device/lib/fields/fields'
import summaryDayVehiclefields from '../list/summary-day-vehicle/lib/fields/fields'
import summaryDayDriverFields from '../list/summary-day-driver/lib/fields/fields'
import summaryFuelFields from '../list/summary-fuel/lib/fields/fields'
import summaryDayFuelFields from '../list/summary-fuel-daily/lib/fields/fields'
import summaryStoppedFields from '../list/summary-stopped/lib/fields/fields'
import temperatureFields from '../list/temperature/lib/fields/fields'
import summaryTripFields from '../list/vehicle-trip/lib/fields/fields'
import fuelRecapitulationFields from '../list/fuel-recapitulation/lib/fields/fields'

export default {
  page: {
    title: 'Form Penjadwalan Laporan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McAlert,
    ModalReportScheduler,
    Contact,
    FilterReport,
  },
  mixins: [Helper, reportFilterFields],
  apollo: {
    reportScheduler: {
      query: GET_DETAIL_REPORT_SCHEDULER,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        }
      },
      skip() {
        return !this.$route.params.id
      },
      result({ data, loading }) {
        if (!loading) {
          if (!data.reportScheduler.isSuccessful) {
            this.$mcToast.warning(data.reportScheduler.message)
          }
          this.initEditPage(data.reportScheduler.reportScheduler)
        }
      },
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        report: null,
        reportKey: '',
        scheduleName: '',
        reportName: '',
        period: 'd',
        noOfDay: { value: 0, text: this.$t('global.days.sunday') },
        time: '17:00',
        timeWeek: '17:00',
        noOfDate: 1,
        timeMonth: '17:00',
        recipients: [],
        filter: null,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: '',
        employeesList: [],
        column: [],
        isSavedReport: false,
      },
      emailList: [],
      isLoaded: false,
      oldData: {},
      isSubmit: false,
      alertsDMS: [49, 51, 52, 53, 54, 55, 56, 110, 111, 50],
      alertsADAS: [90, 91, 92, 113],
      countryCode: '+62',
      employeesList: [],
      lastContactId: 0,
      reportTypeMonthly: 'monthly',
      reportTypeWeekly: 'weekly',
    }
  },
  validations: {
    form: {
      scheduleName: { required },
      reportName: { required },
      noOfDay: {
        required: requiredIf(function () {
          return this.form.period == 'w'
        }),
      },
      noOfDate: {
        required: requiredIf(function () {
          return this.form.period == 'm'
        }),
      },
      startDate: { required },
    },
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
    }),
    defaultColumn() {
      if (this.form.report.key == 'alert') {
        return alertFields
      } else if (this.form.report.key == 'detail-history-vehicle') {
        return detailSummaryTripFields
      } else if (this.form.report.key == 'fuel') {
        return fuelFields
      } else if (this.form.report.key == 'geolocation') {
        return geolocationFields
      } else if (this.form.report.key == 'management-driver') {
        return managementDriverFields
      } else if (this.form.report.key == 'management-vehicle') {
        return managementVehicleFields
      } else if (this.form.report.key == 'offline-vehicle') {
        return vehicleOfflineFields
      } else if (this.form.report.key == 'summary-day') {
        return summaryDayVehiclefields
      } else if (this.form.report.key == 'summary-day-driver') {
        return summaryDayDriverFields
      } else if (this.form.report.key == 'summary-fuel') {
        return summaryFuelFields
      } else if (this.form.report.key == 'summary-day-fuel') {
        return summaryDayFuelFields
      } else if (this.form.report.key == 'summary-stopped') {
        return summaryStoppedFields
      } else if (this.form.report.key == 'temperature') {
        return temperatureFields
      } else if (this.form.report.key == 'history-vehicle') {
        return summaryTripFields
      } else if (this.form.report.key == 'fuel-recapitulation') {
        return this.modifyColumnFuelEfficiency(fuelRecapitulationFields)
      } else {
        return []
      }
    },
    datePickerLang() {
      return datePickerLang()
    },
    displayValueReportName: {
      get() {
        return this.form.reportName.length > 40
          ? this.form.reportName.substring(0, 40) + '...'
          : this.form.reportName
      },
      set(value) {
        this.form.reportName = value
      },
    },
    title() {
      return this.$route.params.id === undefined
        ? this.$t('report.title.reschedule')
        : this.$t('report.title.changeSchedule')
    },
    haveDailyOption() {
      return this.form.report?.key !== 'fuel-recapitulation'
    },
    haveWeeklyOption() {
      return (
        (this.form.report?.key !== 'offline-vehicle' &&
          this.form.report?.key !== 'fuel-recapitulation') ||
        (this.form.report?.key == 'fuel-recapitulation' &&
          this.form.filter?.reportType == this.reportTypeWeekly)
      )
    },
    haveMonthlyOption() {
      return (
        (!this.form.reportKey ||
          mapPeriode31DaysLeft.includes(this.form.report?.key) ||
          mapPeriode31DaysLeft.includes(this.form.report?.reportKey) ||
          (mapCsv.includes(this.form.report?.key) && this.hasCsvScope) ||
          this.form.report?.key == 'cost-analysis' ||
          this.form.report?.key == 'history-vehicle' ||
          (this.form.report?.key == 'fuel-recapitulation' &&
            this.form.filter?.reportType == this.reportTypeMonthly)) &&
        this.form.report?.key !== 'offline-vehicle'
      )
    },
    hasCsvScope() {
      return (
        this.form.report?.downloadOptions?.includes('csv') && this.hasAccess(['csv_report:read'])
      )
    },
    alertDesc() {
      let time = this.form.time
      if (this.form.period === 'w') time = this.form.timeWeek
      if (this.form.period === 'm') time = this.form.timeMonth

      const day = this.dayOptions.find((day) => day.value == this.form.noOfDay.value)
      let result = ''
      if (this.form.period === 'd' && this.form.time && this.form.startDate) {
        result = this.$t('report.text.scheduleDayInfo', {
          time: this.form.time,
          startTime: this.momentDateLongMonth(this.form.startDate),
        })
      } else if (
        this.form.period === 'w' &&
        day.text &&
        this.form.timeWeek &&
        this.form.startDate
      ) {
        result = this.$t('report.text.scheduleWeekInfo', {
          day: day.text,
          time: this.form.timeWeek,
          startTime: this.momentDateLongMonth(this.form.startDate),
        })
      } else if (
        this.form.period === 'm' &&
        this.form.noOfDate &&
        this.form.timeMonth &&
        this.form.startDate
      ) {
        result = this.$t('report.text.scheduleMonthInfo', {
          date: this.form.noOfDate,
          time: this.form.timeMonth,
          startTime: this.momentDateLongMonth(this.form.startDate),
        })
      }

      if (this.form.startDate && this.form.endDate) {
        result += ` ${this.$t('report.text.scheduleDateInfoEnd', {
          endDate: this.momentDateLongMonth(this.form.endDate),
        })}`
      }
      return result
    },
    isInvalidContact() {
      return (
        this.form.employeesList.length <= 0 ||
        this.form.employeesList.every((item) => !item.phoneNumber && !item.email)
      )
    },
    invalidNoOfDate() {
      return `${this.$t('report.object.dateSelection')} ${this.$t('global.validation.required')}`
    },
    stateNoOfDate() {
      return (
        !this.isSubmit ||
        this.form.period !== 'm' ||
        (this.form.period === 'm' && this.form.noOfDate !== '')
      )
    },
    dateOptions() {
      const result = []
      for (let i = 1; i <= 31; i++) {
        result.push(i)
      }
      return result
    },
    invalidSchedulerName() {
      return `${this.$t('report.title.scheduleName')} ${this.$t('global.validation.required')}`
    },
    stateSchedulerName() {
      return !this.isSubmit || this.form.scheduleName.length > 0
    },
    invalidNoOfDay() {
      return `${this.$t('report.object.daySelection')} ${this.$t('global.validation.required')}`
    },
    stateDownloadAs() {
      return !this.isSubmit || this.getFilter().downloadAs
    },
    stateNoOfDay() {
      return (
        !this.isSubmit ||
        this.form.period !== 'w' ||
        (this.form.period === 'w' && this.form.noOfDay !== '')
      )
    },
    isValidTime() {
      if (this.form.period === 'd' && this.form.time) {
        return true
      } else if (this.form.period === 'w' && this.form.timeWeek) {
        return true
      } else if (this.form.period === 'm' && this.form.timeMonth) {
        return true
      } else {
        return false
      }
    },
    dayOptions() {
      return [
        { value: 0, text: this.$t('global.days.sunday') },
        { value: 1, text: this.$t('global.days.monday') },
        { value: 2, text: this.$t('global.days.tuesday') },
        { value: 3, text: this.$t('global.days.wednesday') },
        { value: 4, text: this.$t('global.days.thursday') },
        { value: 5, text: this.$t('global.days.friday') },
        { value: 6, text: this.$t('global.days.saturday') },
      ]
    },
    downloadOptions() {
      const result = this.dropdownItems.reduce((cum, curr) => {
        const result = this.generateDownloadOptions(curr.name)
        if (result) cum.push(result)
        return cum
      }, [])
      return result
    },
    fields() {
      return [
        {
          name: 'user',
          key: 'user.label',
          label: this.$t('notification.setting.emailNotification.recipientName'),
          placeholder: this.$t('notification.setting.emailNotification.recipientName'),
          isEditable: true,
          type: 'select-resourceful-v2',
          optionsGetter: this.resourcefulQuery.employees,
          trackBy: 'id',
          optionLabelFn: ({ item }) => item.label,
          multiple: false,
          taggable: true,
          customColumn: true,
          validationBehavior: 'blur',
          errorBehavior: 'blur',
        },
        {
          name: 'phoneNumber',
          key: 'phoneNumber',
          label: this.$t('notification.setting.emailNotification.whatsappNo'),
          placeholder: this.$t('notification.setting.emailNotification.whatsappNo'),
          type: 'phone-number',
          isEditable: true,
          thStyle: 'width: 300px',
          validation: [['isPhoneNumber', this.countryCode]],
          customColumn: true,
          validationBehavior: 'blur',
          errorBehavior: 'blur',
          disabled: this.hasWhatsapp,
        },
        {
          name: 'email',
          key: 'email',
          label: this.$t('notification.setting.emailNotification.email'),
          placeholder: this.$t('notification.setting.emailNotification.email'),
          isEditable: true,
          type: 'text',
          thStyle: 'width: 400px',
          validation: 'optional|email',
          validationBehavior: 'blur',
          errorBehavior: 'blur',
        },
      ]
    },

    resourcefulQuery() {
      return {
        employees: async (opts) => {
          let result = {}
          let employeeList = this.employeesList

          if (opts?.page === 1) employeeList = []

          let employees = {
            pagination: {
              total: 0,
              page: 1,
            },
            data: [],
          }
          if (opts !== undefined) {
            const filter = {
              pagination: {
                page: opts?.page,
                show: opts?.limit,
              },
              search: opts?.search,
            }

            const res = await this.$apollo.query({
              query: EXPORT_GET_CONTACTS_REPORT,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  ...filter,
                },
              },
            })
            const self = this

            employees = res.data.contactWithUsers.contactWithUsers
            employees.data.forEach((item, index) => {
              employees.data[index].id = self?.lastContactId + index + 1
            })
            if (employees.data.length) {
              self.lastContactId = employees.data[employees.data.length - 1]?.id
            }

            employees.data.map((item) => employeeList.push(item))

            self.employeesList = employeeList
          }

          result = {
            metadata: {
              total_count: employees.pagination.total,
              page: employees.pagination.page,
            },
            data: {
              paginated_result: employees.data,
            },
          }

          return result
        },
      }
    },

    hasWhatsapp() {
      const disabled = this.hasAccessAll(['whatsapp-integration:read'])
      return !disabled
    },

    filterReport() {
      const { downloadAs, ...filter } = this.getFilter()
      const result = {
        ...filter,
        fileType: downloadAs ? [downloadAs] : [],
      }
      if (downloadAs == 'GP') {
        result.labels = []
        if (this.form.report.key == 'temperature') {
          result.labels = [
            'temperature',
            'temperature2',
            'temperature3',
            'acc',
            'refrigerator',
            'door1',
            'door2',
          ]
        } else if (this.form.report.key == 'fuel') {
          result.labels = ['fuelVolume', 'fuelPercentage', 'speed', 'acc']
        }

        if (this.allColumn) {
          result.column = this.allColumn.filter(
            (field) => field != 'address' && field !== 'geofence'
          )
        }
      }
      return result
    },
    listReports() {
      return reportList.filter((report) => report.schedulerEnum !== undefined)
    },
    reportOptions() {
      let reportOptionsHasAccess = []
      this.listReports.forEach((r) => {
        if (!scopeReportScheduler[r.key] || this.hasAccessAll(scopeReportScheduler[r.key])) {
          reportOptionsHasAccess.push(r)
        }
      })

      reportOptionsHasAccess = reportOptionsHasAccess.map((report) => {
        const { label, ...others } = report
        return {
          ...others,
          label: this.$t(label),
        }
      })

      return reportOptionsHasAccess
    },
  },
  watch: {
    countryCode: {
      handler(value) {
        if (value) {
          if (value.includes('+')) this.countryCode = value
          else this.countryCode = `+${value}`
        } else this.countryCode = '+62'
      },
    },
    haveDailyOption(value) {
      if (value) {
        this.form.period = 'd'
      }
    },
    haveWeeklyOption(value) {
      if (value && !this.haveDailyOption) {
        this.form.period = 'w'
      }
    },
    haveMonthlyOption(value) {
      if (value && !this.haveDailyOption && !this.haveWeeklyOption) {
        this.form.period = 'm'
      }
    },
  },
  mounted() {
    this.$apollo.queries.reportScheduler.refetch()
    setTimeout(() => {
      this.isLoaded = true
    }, 1000)
  },
  methods: {
    modifyColumnFuelEfficiency(column) {
      let reportFields = [...column]

      if (!this.form.filter?.reportType || this.form.filter?.reportType == this.reportTypeWeekly) {
        const result = []
        for (let index = 0; index < 4; index++) {
          const field = {
            key: `week${index + 1}`,
            label: `report.fields.week${index + 1}`,
            header: `week ${index + 1}`,
            filter: false,
            width: 30,
            isLocked: true,
            closeChild: true,
            refreshAccordion: false,
            children: [
              {
                key: `fuelConsumption${index + 1}`,
                label: 'report.fields.literConsumption',
                header: 'fuelConsumption',
                filter: false,
                width: 30,
                childOfIndex: index,
                isTopHead: 1,
                headerColspan: 1,
              },
              {
                key: `totalMileage${index + 1}`,
                label: 'report.fields.totalDistance',
                header: 'totalMileage',
                filter: false,
                width: 30,
                childOfIndex: index,
                isTopHead: 0,
                headerColspan: 1,
              },
              {
                key: `actualEfficiency${index + 1}`,
                label: 'report.fields.actualEfficiency',
                header: 'actualEfficiency',
                filter: false,
                width: 30,
                childOfIndex: index,
                isTopHead: 0,
                headerColspan: 1,
              },
            ],
            headerColspan: 3,
          }
          result.push(field)
        }
        reportFields = reportFields.filter(
          (item) => !['fuelConsumption', 'totalMileage', 'actualEfficiency'].includes(item.key)
        )
        const stdEffCol = reportFields.findIndex((item) => item.key === 'standardEfficiency')
        result.forEach((item, i) => {
          reportFields.splice(stdEffCol + i + 1, 0, item)
        })
      } else {
        reportFields = reportFields.filter((item) => !['consistency'].includes(item.key))
      }
      return reportFields
    },
    hasCustomFilters(report) {
      return (
        report?.filter &&
        Object.values(report.filter).some(
          (filterConfig) => filterConfig && filterConfig.isCustom === true
        )
      )
    },
    transformColumnVehicleOffline(column) {
      if (column.includes('license_plate')) {
        column.splice(column.indexOf('license_plate'), 1, 'licensePlate')
      }
      if (column.includes('vgroups')) {
        column.splice(column.indexOf('vgroups'), 1, 'vehicleGroup')
      }
      if (column.includes('offline_date')) {
        column.splice(column.indexOf('offline_date'), 1, 'offlineDate')
      }
      if (column.includes('total_offline_time')) {
        column.splice(column.indexOf('total_offline_time'), 1, 'offlineTimeTotal')
      }
      if (column.includes('last_location')) {
        column.splice(column.indexOf('last_location'), 1, 'offlineLastPlace')
      }
      if (column.includes('last_alert')) {
        column.splice(column.indexOf('last_alert'), 1, 'historyAlertOffline')
      }
      return column
    },
    transformColumn(column) {
      const snakeToCamel = (str) =>
        str.replace(/([-_][a-z])/g, (group) =>
          group.toUpperCase().replace('-', '').replace('_', '')
        )

      return column.map((item) => snakeToCamel(item))
    },
    async initEditPage(item) {
      let { column, fileType, ...filter } = JSON.parse(item.filter)
      this.form.scheduleName = item.scheduleName
      this.form.reportName = item.reportName
      this.form.reportKey = item.reportKey
      this.form.report = this.reportOptions.find((r) => r.key === item.reportKey)
      this.form.period = item.period
      this.form.downloadAs = fileType[0]
      this.form.startDate = item.startTime
        ? moment(item.startTime).format('YYYY-MM-DD')
        : item.startTime
      this.form.endDate = item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : item.endTime
      if (item.period == 'd') {
        this.form.time = item.time
      } else if (item.period == 'w') {
        this.form.noOfDay =
          item.noOfDay !== null
            ? this.dayOptions.find((option) => option.value === item.noOfDay)
            : null
        this.form.timeWeek = item.time
      } else if (item.period == 'm') {
        this.form.noOfDate = item.noOfDay !== null ? item.noOfDay : null
        this.form.timeMonth = item.time
      }
      this.form.filter = filter
      // add id property
      item.contactRecipients.forEach((val, i) => {
        item.contactRecipients[i].id = i + 1
      })
      this.form.employeesList = item.contactRecipients

      if (item.reportKey === 'offline-vehicle') {
        column = this.transformColumnVehicleOffline(column)
      } else if (item.reportKey === 'summary-day') {
        column = this.transformColumn(column)
      } else if (
        item.reportKey == 'fuel-recapitulation' &&
        filter.reportType == this.reportTypeWeekly
      ) {
        column.push('week 1', 'week 2', 'week 3', 'week 4')
      }
      this.form.column = column
      this.form.isSavedReport = item.isSavedReport
      await this.$nextTick()
      this.$refs.filterReportRef.loadData(
        this.form.column,
        filter,
        this.form.downloadAs,
        item.reportKey
      )
      this.$refs.contactRef.loadInitialItems(this.form.employeesList)
    },
    openModal() {
      this.$bvModal.show(this.form.reportName.modal)
    },
    validate() {
      // Checking validation
      this.$v.$touch()
      if (this.$refs.filterReportRef) this.$refs.filterReportRef.validate(true)
      if (
        this.$v.form.$error ||
        !this.isValidTime ||
        !this.validateFilterReport() ||
        !this.stateNoOfDate ||
        !this.stateNoOfDay ||
        !this.stateDownloadAs
      ) {
        return false
      }
      if (this.isInvalidContact) {
        this.$mcToast.error(this.$t('report.text.recipientMustBeFilled'))
        return false
      }
      return true
    },
    toCancel() {
      this.$router.push({ name: 'Report Scheduler' })
    },
    transformFields(formValues) {
      const formValuesKeys = Object.keys(formValues)
      const validKeys = formValuesKeys.filter((key) => formValues[key] !== false)

      return Object.assign(
        {},
        ...validKeys.map((key) => {
          // Get field configuration from reportFilterFields using the custom filter key
          const currentField = this.reportFilterFields[key]
          const value = formValues[key]

          if (currentField && currentField._type === 'number') {
            const isValid = Boolean(value) || value === '0' || value === 0
            return { [key]: isValid ? Number(value) : null }
          } else if (currentField && currentField.type === 'text') {
            if (!formValues[key]) return { [key]: '' }
            return { [key]: formValues[key].trim().replace(/  +/g, ' ') }
          }

          return { [key]: value }
        })
      )
    },
    generateFinalFilter(filter, columns) {
      // Transform numeric fields if report has custom filters configuration
      if (this.hasCustomFilters(this.form.report)) {
        filter = this.transformFields(filter)
      }
      let column = []
      let columnFiltered = columns.filter((item) => item.shown && !item.header?.includes('week'))
      columnFiltered.forEach((c) => {
        if (c.header) column.push(c.header)
        else if (c.children) {
          c.children.forEach((child) => {
            column.push(child.header)
          })
        }
      })
      if (this.form.report.key === 'alert') {
        if (filter.alertCode.includes(94)) filter.alertCode.push(95)

        const filterAlertValues = filter.alertCode.map(Number)
        const hasAlertDMS = filterAlertValues.some((value) => this.alertsDMS.includes(value))
        const hasAlertADAS = filterAlertValues.some((value) => this.alertsADAS.includes(value))
        if (!hasAlertDMS && !hasAlertADAS) {
          column = column.filter((header) => header !== 'download_video')
        }
      }
      filter.column = column
      let motionStatus = []
      if (filter.motionStatus) {
        if (filter.motionStatus.includes('assisted')) {
          motionStatus.push('A')
        }
        if (filter.motionStatus.includes('moving')) {
          motionStatus.push('M')
        }

        filter.motionStatus = motionStatus
      }
      return filter
    },
    toSave() {
      this.isSubmit = true
      let validate = this.validate()
      if (!validate) {
        this.isSubmit = false
        return
      }
      let finalFilter = this.generateFinalFilter(this.filterReport, this.form.column)
      this.form.employeesList = this.form.employeesList.filter((item) => item.id !== undefined)
      const contactFilter = this.generateContactFilter(this.form.employeesList)

      let noOfDay = null
      if (this.form.period === 'w') noOfDay = this.form.noOfDay.value
      else if (this.form.period === 'm') noOfDay = this.form.noOfDate

      let time = this.form.time
      if (this.form.period === 'w') time = this.form.timeWeek
      else if (this.form.period === 'm') time = this.form.timeMonth

      const input = {
        scheduleName: this.form.scheduleName,
        reportName: this.form.reportName,
        reportKey: this.form.reportKey,
        period: this.form.period,
        noOfDay: noOfDay,
        startTime: moment(this.form.startDate + ' 00:00:00.000').toISOString(),
        endTime: this.form.endDate
          ? moment(this.form.endDate + ' 23:59:59.000').toISOString()
          : null,
        time: moment(time, 'HH:mm').format('HH:mm:ss'),
        recipients: null,
        filter: JSON.stringify(finalFilter),
        contactRecipients: contactFilter,
        isSavedReport: this.form.isSavedReport,
      }
      if (this.id === undefined) {
        this.$apollo
          .mutate({
            mutation: CREATE_REPORT_SCHEDULER,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.createReportScheduler.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.added'))
              setTimeout(() => {
                this.$router.push({
                  name: 'Report Scheduler',
                })
              }, 500)
            } else {
              this.isSubmit = false
              return this.$mcToast.error(response.data.createReportScheduler.message)
            }
          })
          .catch((error) => {
            this.isSubmit = false
          })
      } else {
        const edit = {
          id: parseInt(this.id),
          ...input,
        }
        this.$apollo
          .mutate({
            mutation: UPDATE_REPORT_SCHEDULER,
            variables: {
              input: edit,
            },
          })
          .then((response) => {
            if (response.data.updateReportScheduler.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))
              setTimeout(() => {
                this.$router.push({
                  name: 'Report Scheduler',
                })
              }, 500)
            } else {
              this.isSubmit = false
              return this.$mcToast.error(response.data.updateReportScheduler.message)
            }
          })
          .catch((error) => {
            this.isSubmit = false
          })
      }
    },
    changeReport() {
      if (this.form.reportKey == 'offline-vehicle') {
        this.form.period = 'd'
        this.form.noOfDay = { value: 0, text: this.$t('global.days.sunday') }
      }
    },
    openModalReport() {
      if (!this.form.isSavedReport) this.$refs.modalReportScheduler.openModal()
    },
    async onSelect(key) {
      const oldKey = this.form.reportKey
      this.form.reportKey = key
      this.form.report = this.reportOptions.find((item) => item.key === key)
      this.form.reportName = this.form.report.label
      this.changeReport()
      await this.$nextTick()
      await this.$refs.filterReportRef.loadData()
      this.$refs.filterReportRef.keyChanged(oldKey, key)
    },
    disabledRangeStart: function (date) {
      if (this.form.endDate) {
        return new Date(this.momentYmD(date)).getTime() > new Date(this.form.endDate).getTime()
      }
      return false
    },
    disabledRangeEnd: function (date) {
      if (this.form.startDate) {
        return new Date(this.momentYmD(date)).getTime() < new Date(this.form.startDate).getTime()
      }
      return false
    },
    updateData(data) {
      this.form.employeesList = data
    },
    updateCountryCode(value) {
      this.countryCode = value
    },
    addTag(obj) {
      this.employeesList.push(obj)
    },
    generateContactFilter(contact) {
      if (!contact) return []
      const result = contact.map((item) => {
        const label = item.user.fullname ?? item.user.label
        return {
          label: label ? label : null,
          userId: item.user.userId === 9999999 ? null : item.user.userId,
          phoneNumber: item.phoneNumber ? item.phoneNumber : null,
          email: item.email ? item.email : null,
          contactId: item.contactId,
        }
      })
      return result
    },
    getFilter() {
      let finalFilter = {}
      if (this.form.filter) {
        Object.keys(this.form.filter).forEach((key) => {
          if (this.form.filter[key] != null) finalFilter[key] = this.form.filter[key]
        })

        if (finalFilter.vehicleId)
          finalFilter.vehicleId = Array.isArray(finalFilter.vehicleId)
            ? finalFilter.vehicleId.map((item) => parseInt(item))
            : parseInt(finalFilter.vehicleId)

        if (finalFilter.driverId)
          finalFilter.driverId = Array.isArray(finalFilter.driverId)
            ? finalFilter.driverId.map((item) => parseInt(item))
            : parseInt(finalFilter.driverId)

        if (finalFilter.geofenceId)
          finalFilter.geofenceId = Array.isArray(finalFilter.geofenceId)
            ? finalFilter.geofenceId.map((item) => parseInt(item))
            : parseInt(finalFilter.geofenceId)

        if (finalFilter.alertCode)
          finalFilter.alertCode = Array.isArray(finalFilter.alertCode)
            ? finalFilter.alertCode.map((item) => parseInt(item))
            : parseInt(finalFilter.alertCode)

        if (finalFilter.garageId)
          finalFilter.garageId = Array.isArray(finalFilter.garageId)
            ? finalFilter.garageId.map((item) => parseInt(item))
            : parseInt(finalFilter.garageId)

        if (finalFilter.startGeofenceId)
          finalFilter.startGeofenceId = Array.isArray(finalFilter.startGeofenceId)
            ? finalFilter.startGeofenceId.map((item) => parseInt(item))
            : parseInt(finalFilter.startGeofenceId)

        if (finalFilter.endGeofenceId)
          finalFilter.endGeofenceId = Array.isArray(finalFilter.endGeofenceId)
            ? finalFilter.endGeofenceId.map((item) => parseInt(item))
            : parseInt(finalFilter.endGeofenceId)
      }
      return finalFilter
    },
    updateFilter(value) {
      this.form.filter = value
    },
    updateColumn(value) {
      this.form.column = value
    },
    validateFilterReport() {
      const filterReport = this.form.report.filter
      let messageError = ''
      if (filterReport) {
        const { downloadAs, ...others } = this.form.filter
        for (const item of Object.keys(others)) {
          if (
            filterReport[item] &&
            filterReport[item].required &&
            (!this.form.filter[item] || this.form.filter[item].length <= 0)
          ) {
            if (item == 'periode') {
              messageError = `${this.$t('report.object.reportPeriod')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'vehicleId') {
              messageError = `${this.$t('report.fields.licensePlate')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'driverId') {
              messageError = `${this.$t('report.fields.driver')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'alertCode') {
              messageError = `${this.$t('report.fields.alertType')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'garageId') {
              messageError = `${this.$t('report.fields.garage')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'startGeofenceId') {
              messageError = `${this.$t('report.fields.startGeofence')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'endGeofenceId') {
              messageError = `${this.$t('report.fields.stopGeofence')} ${this.$t(
                'global.validation.required'
              )}`
            } else if (item == 'geofenceId' && filterReport[item].required) {
              messageError = `${this.$t('report.fields.geolocation')} ${this.$t(
                'global.validation.required'
              )}`
            }
            break
          } else if (this.hasPeriodeFilter) {
            if (
              !this.hasCsvScope &&
              this.form.report.key === 'history-vehicle' &&
              item == 'vehicleId' &&
              this.form.filter.vehicleId.length > 1 &&
              this.form.period > 'w'
            ) {
              messageError = this.$t('global.validation.7dayPeriod')
              break
            }
            if (
              this.hasIntervalFilter &&
              (this.form.report.key === 'temperature' ||
                this.form.report.key === 'detail-history-vehicle' ||
                this.form.report.key === 'fuel') &&
              this.form.filter.vehicleId &&
              this.form.filter.vehicleId.length > 1 &&
              this.form.filter.interval &&
              this.form.filter.interval === 'all'
            ) {
              messageError = this.$t('report.text.intervalValid')
              break
            }
          }
        }
        if (
          this.form.report.key === 'alert' &&
          this.form.filter.vehicleId &&
          this.form.filter.vehicleId.length > 20 &&
          this.form.filter.alertCode &&
          this.form.filter.alertCode.length > 1
        ) {
          messageError = this.$t('report.text.vehicleAlertSwal')
        }
        if (messageError.length > 0) {
          this.$mcToast.error(messageError)
          return false
        }
      }
      return true
    },
  },
}
</script>
